module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("A")]), _vm._v("ny complicated work such as this requires the help and advice of many people to bring it to fruition and a number of people and organisations deserve my grateful thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Firstly, I must thank my niece Shauna Williams, who resides in Ireland and kindly agreed to travel to the National Library of Ireland in Dublin to photograph the original work for me to transcribe; and to the staff at the library, who aided her greatly in facilitating this. I must also give my grateful thanks to Mary my wonderful wife, who kindly agreed to patiently type out the original text for me to work on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I must also thank my editor Rupert Harding, who believed in this project when few saw its potential and resolutely saw it through to fruition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I often rely on the good services of Ron McGuigan, who patiently searches to find answers to the most complex questions. I have never had the pleasure of meeting Ron, but I regard him as a good friend, who is always willing to help. On the very few occasions that even Ron is left unable to come up with an answer, I can be certain that the information simply does not exist. I must also thank my good friend Robert Burnham who is always happy to bat theories and ideas back and forth without openly calling me an idiot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, I must also thank Andrew Bamford, who has written two excellent books relating to the 12th Light Dragoons and who kindly and generously gave me copies of his notes made on the regiment during the 1815–18 period.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Gareth Glover, Cardiff 2021")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40121bba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgements.vue
// module id = 75
// module chunks = 0